<template>
<div
  class="div-table__row div-table__row--select"
  :class="{'path_item_inactive': directLinking}"
>
  <span class="ml-12 ml-first-0">{{ landingIndex + 1 }}</span>
  <ui-select
    :value="landing"
    :items="landingOptions"
    item-text="nameFull"
    item-value="id"
    :return-object="true"
    :error="generalErrorMessages"
    @change="onChange"
    :fetchOptions="fetchLandingOptions"
    class="ml-12 flow-row-select"
    :hideDetails="1"
    :loading="!store.cache.landings.isUploaded"
  >
    <template #item="{ item, props: itemProps }">
      <v-list-item
        v-bind="listItemBind(itemProps)"
        :link="false"
        :title="null"
        @click.stop="onLandingItemClick(itemProps, $event)"
      >
        <div :title="landingLabel(item)">
          {{ landingLabel(item) }}
        </div>
      </v-list-item>
    </template>
  </ui-select>
  <div class="table-popup__input-weight">
    <v-text-field
      v-model="landing.weight"
      class="weight-input"
      type="number"
      density="compact"
      hide-details
      variant="plain"
      :disabled="isDisabledWeight"
      :error-messages="weightErrorMessages"
    ></v-text-field>
    <span :class="{ disabled: isDisabledWeight }">({{ landingPercentage }}%)</span>
  </div>
  <div class="table-popup__wrap-icon">
    <ui-icon
      v-if="landing.id"
      @click="emit('preview', landingUrl)"
      size="14"
      :color="$colors.gray50"
      icon="fas fa-external-link"
    ></ui-icon>
    <ui-icon
      v-if="landing.id"
      @click="emit('edit')"
      size="14"
      :color="$colors.gray50"
      icon="fas fa-pencil-alt"
    ></ui-icon>
    <ui-icon @click="emit('delete')" size="14" :color="$colors.gray50" icon="fas fa-trash-alt"></ui-icon>
  </div>
</div>
</template>

<script setup lang="ts">
import { useStore } from '@/store';
import { useColors } from '@/composables';
import { useCampaignFlowLanding } from './useCampaignFlowLanding';

const store = useStore();

const $colors = useColors();
const props = withDefaults(
  defineProps<{
    path: {
      landings: Array<{ id: string; weight: number; offers?: number; url?: string }>;
      offers: Array<{ id: string; weight: number }>;
    };
    ruleIndex: number;
    pathIndex: number;
    landingIndex: number;
    landing: { id: string; weight: number; offers?: number; url?: string };
    directLinking: boolean;
    isDisabledWeight?: boolean;
    totalWeight: number;
    errorConditionPrefix?: string[];
    errorsRaw: unknown[][] | null;
    landingOptions: Landing[];
    form: {
      workspaceId: string;
      countryId?: string;
    };
  }>(),
  {
    isDisabledWeight: false,
    errorConditionPrefix: () => [],
  },
);

const emit = defineEmits<{
  delete: [];
  edit: [];
  preview: [url: string];
  'fix-landing-count': [item: { offers: number }, preserveLandings?: boolean];
}>();

const {
  fetchLandingOptions,
  generalErrorMessages,
  weightErrorMessages,
  landingUrl,
  landingPercentage,
  onChange,
} = useCampaignFlowLanding(props, emit);

const landingItem = (item: { raw?: Landing } & Partial<Landing>) =>
  (item?.raw ?? item) as Landing;

const landingLabel = (item: { raw?: Landing } & Partial<Landing>) => {
  const landing = landingItem(item);
  return landing.nameFull || landing.name || '';
};

const listItemBind = (itemProps: Record<string, unknown>) => {
  const { title: _title, subtitle: _subtitle, onClick: _onClick, ...rest } = itemProps;
  return rest;
};

const onLandingItemClick = (
  itemProps: Record<string, unknown>,
  event: MouseEvent,
) => {
  if (itemProps.disabled) return;
  const handler = itemProps.onClick;
  if (typeof handler === 'function') {
    (handler as (event: MouseEvent) => void)(event);
  }
};
</script>
